export default "__VITE_ASSET__Z9fn_uD$__"